import React, { Component, PropTypes } from 'react';
import baseUrl from '../../../utils/baseUrl';

import ContentBlock from '../block/content';
import FormFitter from '../../form/decorators/formfitter';

import Form from '../../form/form';
import InputText from '../../form/input/text';

import InputWysiwyg from '../../form/wysiwyg/wysiwyg';
import InputTagSelect from '../../form/tagselect/tagselect';
import Label from '../../form/label';
import ConfirmDialog from '../../form/confirm';

import translate from '../../../utils/translate';
// import * as actions from '../../actions/account';

export default class JobEditForm extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		smallAside: PropTypes.bool.isRequired,
		path: PropTypes.string.isRequired,

		head: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]).isRequired,
		foot: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]).isRequired,
		job: PropTypes.object,
		user: PropTypes.object.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		smallAside: false,
		path: '',

		head: false,
		foot: false,
		job: {},

		onSubmit: () => {},
	};

	constructor() {
		super();

		this.state = {
			profileCreated: false,
		};
	}

	render() {
		const { job } = this.props;

		return (
			<Form getRefs={() => this.getRefs()} ref='form' method='put' action={this.props.path} smallAside={this.props.smallAside} onSubmit={this.props.onSubmit} head={this.props.head} dispatch={this.props.dispatch}>
				<ContentBlock title='Job vacancy at' smallAside={this.props.smallAside}>
					<Label label='Company name' btw=' (vacancies are posted to the FWA "JOBS" section and also to the FWA Profile page of FWA winners)' />
					<FormFitter className='span3 span5-tablet span11-mobile'>
						<ConfirmDialog ref='confirm' />
						<InputTagSelect
							ref='company'
							name='company'
							value={job.profiles}
							placeholder='Type to search for FWA Profiles'
							maxSelected={1}
							path={`${baseUrl}/api/profiles/search`}
							showLink={((this.props.user && !this.props.user.profile) && !this.state.profileCreated)}
							link={{
								url: `${baseUrl}/account/profile/settings/`,
								text: 'Create profile',
								onClick: (e, val, createEntry) => {
									e.preventDefault();
									const breakRegex = /<br\s*[\/]?>/gi;
									const confirmText = translate('account/jobcreate/addProfilePopup', false).replace('%name%', val).replace(breakRegex, '\n');
									const buttonOk = 'Yes, create profile';
									const buttonCancel = 'Cancel';

									this.refs.confirm.confirm(confirmText, buttonOk, buttonCancel)
									.then(() => {
										this.setState({
											...this.state,
											profileCreated: true,
										});
										createEntry({
											myProfile: 1,
											onDelete: () => {
												this.setState({
													...this.state,
													profileCreated: false,
												});
											}
										});
									})
									.catch(() => {});
								},
							}}
							onChange={() => {}}
						/>
					</FormFitter>
				</ContentBlock>

				<ContentBlock title='Job basics' smallAside={this.props.smallAside}>
					<FormFitter className='span3 span5-tablet span11-mobile'>
						<InputText ref='title' name='title' label='Job Title' btw='' value={job.title} placeholder='Descriptive job title' />

						<InputText ref='address' name='address' label='Address (Optional)' btw='' value={job.address} placeholder='Address' />

						<InputText ref='city' name='city' label='Location City' btw='' value={job.city} placeholder='City' />

						<InputText ref='zip' name='zip' label='Postal or zipcode (Optional)' btw='' value={job.zip} placeholder='Zipcode' />

						<InputText ref='country' name='country' label='Location Country' btw='' value={job.country} placeholder='Country' />
					</FormFitter>
				</ContentBlock>

				<ContentBlock title='Job details' smallAside={this.props.smallAside}>
					<FormFitter className='span5 span8-tablet span11-mobile'>
						<Label label='Job description' btw='' />
						<InputWysiwyg ref='description' label='Job description' name='description' value={job.description} placeholder='Describe the position' />

						<Label label='How to apply' btw='' />
						<InputWysiwyg ref='howTo' name='howTo' label='How to apply' value={job.howTo} placeholder='Describe how to apply' />

						<span className='custom-label__helptext'>
							Make sure you don’t forget to add an email address to be published on the site or a URL for applicants to click on.
						</span>
					</FormFitter>
				</ContentBlock>

				{this.props.foot}
			</Form>
		);
	}

	getRefs() {
		return this.refs;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobCreate/jobEditForm.js
 **/